import * as React from 'react';
import * as gravatar from 'gravatar';

const Avatar = ({ email, name = 'Avatar', size = 64 }) => (
  <span className={`avatar image is-${size}x${size}`}>
    <img src={gravatar.url(email, { s: size * 2, d: 'mm' })} alt={name} />
  </span>
);

export default Avatar;
